import { Device, from } from '@helpers/media';
import React from 'react';
import { useMedia } from 'react-use';
import SimpleMenuStyles from './SimpleMenu.styles';
const SimpleMenu = ({ isActive = false, items, mobileAccordion = true, title, onToggle, }) => {
    if (!items) {
        return null;
    }
    const isDesktop = useMedia(from(Device.TabletLarge), true);
    return (React.createElement(SimpleMenuStyles.Container, { initial: "closed", animate: isDesktop || !mobileAccordion || isActive ? 'open' : 'closed', variants: {
            closed: {},
            open: {},
        }, mobileAccordion: mobileAccordion },
        title && (React.createElement(SimpleMenuStyles.Header, { onClick: (event) => {
                event.preventDefault();
                if (mobileAccordion && onToggle) {
                    onToggle();
                }
            } },
            React.createElement(SimpleMenuStyles.Title, null, title),
            React.createElement(SimpleMenuStyles.Toggle, { variants: {
                    closed: {
                        rotate: 0,
                    },
                    open: {
                        rotate: 180,
                    },
                } },
                React.createElement(SimpleMenuStyles.ToggleIcon, null)))),
        React.createElement(SimpleMenuStyles.List, { variants: {
                closed: {
                    height: 0,
                },
                open: {
                    height: 'auto',
                },
            }, transition: { type: 'tween' } }, items.map((item) => (React.createElement(SimpleMenuStyles.Item, { key: item.id },
            React.createElement(SimpleMenuStyles.Link, { href: item.url, target: item.target }, item.text)))))));
};
export default SimpleMenu;
